import React, { useEffect, useState } from 'react'
import { Button } from '../../../components/button/button';
import Input from '../../../components/input/Input';
import Label from '../../../components/title/label';
import Table from '../../../components/table/Table';
import {  useNavigate } from 'react-router-dom';
import axios from 'axios';
import Modal from '../../../components/modals/Modal';
import Checkbox from '../../../components/button/Checkbox';
import { IoIosPerson } from "react-icons/io";
import { HiOutlineInformationCircle } from "react-icons/hi";
import { ImStatsDots } from "react-icons/im";
import { FaCar, FaUniversity } from "react-icons/fa";
import { BiBody } from "react-icons/bi";
import {  MdOutlineCached, MdPermIdentity} from "react-icons/md";
import { BACKEND_URL, E_immatriculation } from '../../../constants/constant';
import { Navbar } from '../../../components/navbar/Navbar';
import BackButton from '../../../components/button/BackButton';

function SituationGeographiqueIm() {

  let navigate = useNavigate();
  const [isModalError, setIsModalError] = useState(false);
  const [isModalSucess, setIsModalSuccess] = useState(false);
  

 
  const selectedData = localStorage.getItem("selectedDataPriseEnCharge");
 
  const [ContribuableData] = useState(
  JSON.parse(selectedData)
);

const [AllAssujetissement , setAllAssujetissement] = useState([]);
const [AllCoordonnees  , setAllCoordonnees] = useState([]);

const [ assujetissement , setAssujetissement ] = useState([]);
const [ coordonnees , setCoordonnees ] = useState([]);
 

const filterId = ContribuableData.id;
useEffect(() => {
  const filteredData = AllAssujetissement.filter(
    (item) => item.id_contribuable === filterId
  );
  setAssujetissement(filteredData); // Now it will always be an array
}, [AllAssujetissement, filterId]);


useEffect(() => {
  const filteredData = AllCoordonnees.filter(
    (item) => item.id_contribuable === filterId
  );
  setCoordonnees(filteredData); // Now it will always be an array
}, [AllCoordonnees, filterId]);

    useEffect(() => {
      
          axios.get(`${E_immatriculation}/assujetissement`)
              .then((response) => {
                  const data = response.data;
                  setAllAssujetissement(data);
              })
              .catch((error) => {
                  console.error('Error fetching data:', error);
                  setIsModalError(true);
              });
      
  }, []); 

  
  useEffect(() => {
      
    axios.get(`${E_immatriculation}/coordonnees`)
        .then((response) => {
            const data = response.data;
            setAllCoordonnees(data);
        })
        .catch((error) => {
            console.error('Error fetching data:', error);
            setIsModalError(true);
        });

}, []); 


  console.log("coordonnées" , coordonnees)
  
  console.log("assujetissement" , assujetissement)
  

  const handlePriseEnCharge = () => {
    // Perform data verification logic here
    if (ContribuableData.reference_fiscal) {
      // Data is verified, set isDataVerified to true
      
  
      // Update the data object with the prise_charge property
      const updatedData = { reference_fiscal : ContribuableData.reference_fiscal , id_contribuable : ContribuableData.id , prise_charge: true };
  
      // Send the updated data to the backend
      axios.post(`${BACKEND_URL}/prisecharge`, updatedData)
        .then((response) => {
          // Handle the response from the backend, if needed
         setIsModalSuccess(true);
        })
        .catch((error) => {
          console.error('Error sending verification data:', error);
          setIsModalError(true);
        });
    }
  };
  

  const headers = [
    "numero",
    "imposition",
    "date_debut",
    "periodicite",
    "annee",
    "exonere",
    "period_1",
    "period_2",
    "etat",
     "date_exe",
    "date_assujetissement",
    "date fin"

  ];

  const dataAssujetissement = Array.isArray(assujetissement) 
  ? assujetissement.map((item) => [
      item.id,
      item.imposition,
      item.date_debut,
      item.periodicite,
      item.annee,
      <Checkbox onChange={() => window} checked={item.exonere}></Checkbox>,
      item.period_1,
      item.period_2,
      item.etat,
      item.date_exe,
      item.date_assujetissement,
      item.date_fin,
    ])
  : [];




  const clearLocalStorage = () => {
    localStorage.clear();
    navigate("/PriseChargeIm");
    console.log("LocalStorage vidé !");

  };

  const contentNavbar = (
    <nav className="flex items-center justify-between">
     <div className='text-white'>
      Voir Contribuable
     </div>
      <BackButton onClick={clearLocalStorage}></BackButton>
    </nav>
  ) 

  
 
  
     return (
       <div  className='bg-[#212122] h-screen w-screen'>
    <div className="h-screen w-screen">
      <Navbar content={contentNavbar} />
      <main className="">       <div className='overflow-x-auto h-[600px]' >
    
    <div className="m-4 mb-4">
       
       <div className="text-white bg-black py-3 px-4 rounded  text-3xl  font-semibold  "> Détails d'un contribuable  : {ContribuableData?ContribuableData.raison_social:""}</div>
<div className="flex flex-col">
<div className="flex items-center justify-center p-2">
 <div className="flex flex-col">

 <div className="flex flex-col  ">
<div className="p-2 mx-4">
 </div>
 <div onClick={()=>navigate("/renseignement-general")} className=" w-[750px] text-white    py-3  px-4 flex flex-row shadow-xl border-[1px] font-semibold cursor-pointer ">
 <HiOutlineInformationCircle className="text-xl mx-2 font-semibold"></HiOutlineInformationCircle>
 Principaux renseignements
 </div>
 

 <div  onClick={()=>navigate("/activite-contribuable")} className="w-full w-[750px] text-white  py-3 px-4 flex flex-row shadow-xl border-[1px] font-semibold cursor-pointer ">
 <ImStatsDots className="text-xl mx-2"></ImStatsDots>
 Activités
 </div>
 
 <div onClick={()=> navigate("/siege-contribuable")} className=" text-white w-[750px] py-3 px-4  flex flex-row shadow-xl border-[1px] font-semibold cursor-pointer  ">
 <FaUniversity className="text-xl  mx-2"></FaUniversity>
 Siège
 </div>
 

{ ContribuableData.type === "Personne morale" ? (
 <>
<div onClick={()=>navigate("/association-contribuable")} className="text-white  w-[750px] py-3  px-4 flex flex-row shadow-xl border-[1px] font-semibold cursor-pointer w-full">
 <BiBody className="text-xl mx-2"></BiBody>
 Associé
 </div>
 
 </>
):(
<>
</>
)
}

{ ContribuableData.type === "Personne morale" ? (
 <>
 <div onClick={()=> navigate("/etablissement-contribuable")} className=" w-[750px] text-white py-3 px-4 flex flex-row shadow-xl border-[1px] font-semibold cursor-pointer w-full">
 <FaUniversity className="text-xl mx-2"></FaUniversity>
 Etablissement
 </div>
 
 </>
) : (
 <>
 
 </>
)

}


{ ContribuableData.type === "Personne morale" ?(
 <>
 <div onClick={()=> navigate("/dirigeant-contribuable")} className=" py-3 w-[750px] text-white px-4 flex flex-row shadow-xl border-[1px] font-semibold cursor-pointer w-full">
 <MdPermIdentity className="text-xl mx-2"></MdPermIdentity>
 Dirigant
 </div>

 </>
)
: 
(
 <>

 </>
)

}


{
  
 ContribuableData.type === "Personne morale"  ?
(
<>
<div onClick={()=> navigate("/interlocuteur-contribuable")} className=" w-[750px] text-white  py-3  px-4 flex flex-row shadow-xl border-[1px] font-semibold cursor-pointer w-full">
 <IoIosPerson className="text-xl mx-2"></IoIosPerson>
 Interlocuteur
 </div>

</>

) :
(
 <>
 </>

)

}

<>
<div onClick={()=> navigate("/autre-contribuable")} className=" w-[750px] text-white    py-3  px-4 flex flex-row shadow-xl border-[1px] font-semibold cursor-pointer w-full">
 <MdOutlineCached  className="text-xl mx-2"></MdOutlineCached >
 Autre
 </div>


</>
<>
<div onClick={()=> navigate("/vehicule-contribuable")} className=" w-[750px] text-white    py-3  px-4 flex flex-row shadow-xl border-[1px] font-semibold cursor-pointer w-full">
 <FaCar  className="text-xl mx-2"></FaCar >
 Vehicule
 </div>


</>

</div>
 </div>
</div>

<div className="flex flex-col mt-4 rounded h-[500px] p-4">
<div className="flex flex-row">

<Label text={`régime d'imposition :`} className="ml-4"></Label>

</div>

<div className="  mt-6 overflow-y-auto h-[400px]">
 <Table
 // onClick={handleTableRowClickEntries}
 // selectedRowIndex={selectedRowIndexEntries}
headers={headers}
data={dataAssujetissement}
></Table>
</div>
</div>

<div className="flex flex-col  mt-4 rounded h-[220px] p-4">
<Label text={`Coordonnées géographique :`} className="ml-4"></Label>
<div className="mt-6 flex flex-row justify-between ">
<Label text="Longitude" className="mt-4"></Label>
<Input type="text" className="w-96  "
value={coordonnees ? coordonnees[0]?.longitude : ""}

></Input>
</div>
<div className="mt-6 flex flex-row justify-between ">
<Label text="Laltitude" className="mt-4"></Label>
<Input type="text" className="w-96  "

value={coordonnees ?coordonnees[0]?.latitude : ""}

></Input>
</div>

</div>

</div>


 
   </div>


     <div className='mt-6 '>
   
         <div className='flex mt-2 justify-end mr-4'>      
           <Button type="submit" children="Prise en Charge" onClick={handlePriseEnCharge} ></Button>
         </div>
         </div>
 
       </div></main>
    </div>
        <Modal isOpen={isModalError} onClose={()=> setIsModalError(false)} className="w-[500px] h-[200px]">
          <div className='flex  justify-center'>
            <div className='flex flex-col mt-14'>
            <Label text="Il y a une erreur" className="text-xl"></Label>
<Button children="OK"  onClick={()=> setIsModalError(false)} className="mt-4"></Button>
            </div>
          </div>
        </Modal>
        <Modal isOpen={isModalSucess} onClose={()=> setIsModalSuccess(false)} className="w-[500px] h-[200px]">
          <div className='flex  justify-center'>
            <div className='flex flex-col mt-14'>
            <Label text="Donné prise en charge" className="text-xl"></Label>
<Button children="OK"  onClick={()=> navigate("/PriseChargeIm")} className="mt-4"></Button>
            </div>
          </div>
        </Modal>
       </div>
     )
}

export default SituationGeographiqueIm